import React from 'react';

export default function Scholarship() {
    const isEnglish = window.location.pathname.includes('/en');

    return (
        <div className="container my-5">
            <div className="bg-light p-4 rounded shadow-sm">
                <h3 className="text-center fw-bold mb-4">
                    {isEnglish ? 'Scholarship Department' : 'छात्रवृत्ति शाखा'}
                </h3>

                <h5 className="fw-bold">{isEnglish ? 'Functions and Objectives:' : 'कार्य एवं उद्देश्य:'}</h5>

                <p>
                    {isEnglish
                        ? 'This department is responsible for providing various types of scholarships to university students, smoothly managing their application process, and implementing scholarship schemes related to Government/UGC/other agencies.'
                        : 'विश्वविद्यालय के विद्यार्थियों को विभिन्न प्रकार की छात्रवृत्तियाँ प्रदान करने, उनके आवेदन की प्रक्रिया को सुचारु रूप से संचालित करने एवं शासन/यूजीसी/अन्य एजेंसियों से संबंधित छात्रवृत्ति योजनाओं के कार्यान्वयन हेतु यह शाखा उत्तरदायी है।'}
                </p>

                <p>
                    {isEnglish
                        ? 'The university ensures the proper implementation of various schemes of the University Grants Commission (UGC), Government of India, and State Government related to admissions, scholarships, etc., for the welfare of reserved category students.'
                        : 'विश्वविद्यालय आरक्षित वर्गों के छात्रों के कल्याण हेतु प्रवेश, छात्रवृत्तियों आदि से संबंधित विश्वविद्यालय अनुदान आयोग (UGC), भारत सरकार, एवं राज्य सरकार की विभिन्न योजनाओं के उचित कार्यान्वयन को सुनिश्चित करता है।'}
                </p>

                <p>
                    {isEnglish
                        ? 'Guidelines issued from time to time by the Central and State Governments are sent to the concerned departments/colleges.'
                        : 'समय-समय पर केंद्र एवं राज्य सरकार द्वारा जारी किए गए दिशानिर्देश संबंधित विभागों/महाविद्यालयों को प्रेषित किए जाते हैं।'}
                </p>

                <p>
                    {isEnglish
                        ? 'For the convenience of students, scholarship application forms are communicated to the heads of the concerned departments and made available.'
                        : 'छात्रों की सुविधा के लिए छात्रवृत्ति आवेदन पत्र संबंधित विभागाध्यक्षों को सूचित कर उपलब्ध कराया जाता है।'}
                </p>

                <h5 className="fw-bold mt-4">{isEnglish ? 'Major Scholarships:' : 'प्रमुख छात्रवृत्तियाँ:'}</h5>
                <ul className="mt-2">
                    <li>{isEnglish ? 'Post Matric Scholarship' : 'पोस्ट मैट्रिक छात्रवृत्ति'}</li>
                    <li>{isEnglish ? 'Scheduled Caste and Scheduled Tribe Scholarship' : 'अनुसूचित जाति व अनुसूचित जनजाति छात्रवृत्ति'}</li>
                    <li>{isEnglish ? 'Shankarlal Bhagirathi Scholarship' : 'शंकरीलाल भागीरथी छात्रवृत्ति'}</li>
                    <li>{isEnglish ? 'Meritorious Scholarship (Maharshi Valmiki Sanskrit University, Kaithal)' : 'मेधावी छात्रवृत्ति (महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल)'}</li>
                    <li>{isEnglish ? 'Research Scholarship (for research scholars)' : 'शोध छात्रवृत्ति (शोधार्थियों के लिए)'}</li>
                    <li>{isEnglish ? 'Haryana Culture Academy, Panchkula' : 'हरियाणा संस्कृति अकादमी, पंचकुला'}</li>
                    <li>{isEnglish ? 'Scholarship given to students studying Sanskrit by the Central Sanskrit University' : 'केन्द्रीय संस्कृत विश्वविद्यालय द्वारा संस्कृत अध्ययन करने वाले छात्रों को दी जाने वाली छात्रवृत्ति'}</li>
                </ul>

                <h5 className="fw-bold mt-4">{isEnglish ? 'Officers and Members in Scholarship Department:' : 'छात्रवृत्ति शाखा में कार्यरत अधिकारी एवं सदस्य'}</h5>

                <div className="table-responsive mt-3">
                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th scope="col">{isEnglish ? 'S. No.' : 'क्रं. सं.'}</th>
                                <th scope="col">{isEnglish ? 'Member Name' : 'सदस्य का नाम'}</th>
                                <th scope="col">{isEnglish ? 'Designation' : 'पद'}</th>
                                <th scope="col">{isEnglish ? 'Official Email' : 'अधिकारिक ई-मेल'}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>{isEnglish ? 'Mr. Ankur Gupta' : 'श्री अंकुर गुप्ता'}</td>
                                <td>{isEnglish ? 'Superintendent, Academic Branch' : 'अधीक्षक, शैक्षणिक शाखा'}</td>
                                <td>academic@mvsu.ac.in</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>{isEnglish ? 'Mr. Praveen Kumar' : 'श्री प्रवीन कुमार'}</td>
                                <td>{isEnglish ? 'Assistant, Scholarship Branch' : 'सहायक, छात्रवृति शाखा'}</td>
                                <td>academic@mvsu.ac.in</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>{isEnglish ? 'Mr. Sikander Lal' : 'श्री सिकन्दर लाल'}</td>
                                <td>{isEnglish ? 'D.E.O., Scholarship Branch' : 'डी.ई.ओ., छात्रवृत्ति शाखा'}</td>
                                <td>sch@mvsu.ac.in</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
